let LV_Row_PrevClass;

window.LV_Row_MouseOver = function (el){
	LV_Row_PrevClass = el.className;
	el.className = 'LV_HIGHLIGHTROW';
}

window.LV_Row_MouseOut = function (el){
	el.className = LV_Row_PrevClass;
}
